<template>
  <!-- Bubble / Lingkaran Abstrak -->
  <div class="absolute inset-0 pointer-events-none overflow-hidden">
    <!-- Bubble besar kanan atas -->
    <div
      class="absolute -top-3 -right-8 w-40 h-40 rounded-full bg-white opacity-10"
    ></div>
    <!-- Bubble sedang kiri bawah -->
    <div
      class="absolute -bottom-10 -left-6 w-32 h-32 rounded-full bg-white opacity-10"
    ></div>
    <!-- Bubble kecil outline tengah kanan -->
    <div
      class="absolute top-4 right-[100px] w-10 h-10 rounded-full border border-white opacity-20"
    ></div>
    <!-- Bubble kecil solid kiri tengah -->
    <div
      class="absolute top-6 left-1/3 w-5 h-5 rounded-full bg-white opacity-10"
    ></div>
  </div>
</template>